import React from "react";
import CommitteeCard from "./CommitteeCard";

const committeeLeader = {
  name: "Dr. DSPA Baragamage",
  position: "President",
  image: "/board/baragamage.png",
};

const executiveCommittee = [
  {
    name: "Dr. Pasan Henadeera",
    position: "Senior Vice President",
    image: "/board/pasan.png",
  },
  {
    name: "Dr. Mahesh Hordagoda",
    position: "Senior Treasurer",
    image: "/board/hordagoda.png",
  },
];

const committeeMembers = [
  {
    name: "Mr. Decon Kelart ",
    position: "Vice President",
    image: "/board/decon.png",
  },
  {
    name: "Mr. Mayuka Hiranya",
    position: "Vice President",
    image: "/board/mayuka.png",
  },
  {
    name: "Mr. Chamidu Nesath",
    position: "Treasurer",
    image: "/board/chamidu.png",
  },
  {
    name: "Miss. Pamudi Mendis",
    position: "Secretary",
    image: "/board/pamudi.png",
  },
  {
    name: "Mr. Navindu Karunarathna",
    position: "Assistant Secretary",
    image: "/board/navidu.png",
  },
  {
    name: "Mr. Dilshan Salporodu ",
    position: "Social Secretary",
    image: "/board/dilshan.png",
  },
  {
    name: "Miss. Lochinie Rubasinghe",
    position: "Editor",
    image: "/board/lochini.png",
  },
  {
    name: "Mr. Yasiru Nilupul",
    position: "Editor",
    image: "/board/yasiru.png",
  },
  {
    name: "Mr. Ishan Sasanka",
    position: "Committee Member",
    image: "/board/ishan.png",
  },
  {
    name: "Mr. Janindu Sachinthana",
    position: "Committee Member",
    image: "/board/janidu.png",
  },
  {
    name: "Mr. Aruth Fernando",
    position: "Committee Member",
    image: "/board/aruth.png",
  },
  {
    name: "Mr. Saniru Vinoshan",
    position: "Committee Member",
    image: "/board/saniru.png",
  },
  {
    name: "Mr. Chamod Wijesinghe",
    position: "Committee Member",
    image: "/board/chamod.png",
  },
  {
    name: "Mr. Dakshina Weerakoon",
    position: "Committee Member",
    image: "/board/dakshina.png",
  },
  {
    name: "Mr. Ulindu Iresha",
    position: "Committee Member",
    image: "/board/ulindu.png",
  },
  {
    name: "Mr. Yumira Damsandu",
    position: "Committee Member",
    image: "/board/yumira.png",
  },
];

const BoardOfOfficials = () => {
  return (
    <section id="board" className="relative py-20 overflow-hidden">
      {/* Modern Dynamic Background with Animated Elements */}
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-blue-50/20 to-indigo-50/30 dark:from-gray-950 dark:via-blue-950/10 dark:to-indigo-950/20">
        {/* Subtle geometric animations */}
        <div className="absolute top-20 left-10 w-96 h-96 bg-blue-300/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-40 right-20 w-80 h-80 bg-indigo-300/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/3 left-1/4 w-60 h-60 bg-purple-300/10 rounded-full blur-3xl animate-pulse delay-700"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Modern Section Title with Animated Underline */}
        <div className="text-center mb-16">
          <div className="inline-block">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-black bg-black bg-clip-text text-transparent mb-4 leading-tight">
              Board of Executives
            </h2>
            <div className="h-1.5 w-1/3 bg-gray-900 rounded-full mx-auto transform transition-all duration-300 animate-pulse"></div>
          </div>

          <div className="text-xl md:text-2xl font-bold text-gray-700 dark:text-gray-300 mt-6 mb-2">
            UMMES 25/26
          </div>
        </div>

        <div className="mb-14">
          {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 max-w-6xl mx-auto">
            <CommitteeCard member={executiveCommittee[0]} />
            <CommitteeCard member={committeeLeader} isLeader />
            <CommitteeCard member={executiveCommittee[1]} />
          </div> */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
            <div className="md:col-start-1 md:col-end-2 order-2 md:order-1">
              <CommitteeCard member={executiveCommittee[0]} />
            </div>
            <div className="md:col-start-2 md:col-end-3 order-1 md:order-2">
              <CommitteeCard member={committeeLeader} isLeader />
            </div>
            <div className="md:col-start-3 md:col-end-4 order-3">
              <CommitteeCard member={executiveCommittee[1]} />
            </div>
          </div>
        </div>

        {/* Committee Members - Modern Grid Layout */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {committeeMembers.map((member, idx) => (
            <CommitteeCard key={idx} member={member} small />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BoardOfOfficials;
